module.exports = __webpack_public_path__ + "static/media/mail.6a12cacf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Team/AboutBox/img/mail.svg
// module id = 293
// module chunks = 0